import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import _isEqual from 'fast-deep-equal'
// import { VariableSizeList as ReactWindowList } from 'react-window'

// styles
import '../App.css'

import StyledDateRangePicker from './StyledDateRangePicker';
import MUIDataTable from 'mui-datatables';

// mui components
import { ThemeProvider, createTheme } from '@mui/material/styles';
// import createCache from '@emotion/cache';
import { Box, CircularProgress, Typography } from '@mui/material';

//package library component
import Select from 'react-select';

// Actions and Reducers
import { stackLoadedAndSocketData } from '../Redux/Actions/mapDataActions'
import { setRenderSinglePoint, setRunLoader, setSingleDataPoint } from '../Redux/Reducers/mapDataReducer'
import { setSelectedDistrict, setHomePanelName, setStartDate, setEndDate } from '../Redux/Reducers/commonReducer'
import { fetchCnlPlaceByUcode, fetchPlaceByUcode, fetchRetailPlaceByUcode } from '../utils/fetchUtils'
import ReactWindowList from './common/ReactWindowList';
import { getCnlRoutes, getCnlTerritories, getMarketOpportunities, getOutletCategories, getOutletTypes } from '../Redux/Actions/cnlActions';
import { setStartDateType } from '../Redux/Reducers/cnlReducer';


class LoaderPanelCnl extends React.PureComponent {
    constructor(props){
      super(props);
      this.state = {
          value: 0,
          AllFilteredData: [],
          tableRow: [],
          startDateType: 0
      }
    }

    componentDidMount(){
        const { staticPoints, points, socketRetailDataPoints, selectedDistrict, dispatch } = this.props
        if( points.length > 0 || socketRetailDataPoints.length > 0 ){
            const transformedDataForTable = stackLoadedAndSocketData(points, [], selectedDistrict).messageData
            this.setState({
                tableRow: transformedDataForTable
            })
        }
        this.setState({ AllFilteredData: staticPoints })
        dispatch(setHomePanelName('loader'))
        dispatch(getOutletTypes());
        dispatch(getOutletCategories());
        dispatch(getMarketOpportunities());
        dispatch(getCnlTerritories());
        dispatch(getCnlRoutes());
    }
  

    componentDidUpdate(prevProps, prevState){
        const { staticPoints, points, socketRetailDataPoints, selectedDistrict } = this.props
        const { AllFilteredData } = this.state
        if (!_isEqual(staticPoints, AllFilteredData)){
            this.setState({ AllFilteredData: staticPoints })
            }
        if(!_isEqual(prevProps.points, points) || !_isEqual(prevProps.socketRetailDataPoints, socketRetailDataPoints) || !_isEqual(prevProps.selectedDistrict, selectedDistrict)){
            const transformedDataForTable = stackLoadedAndSocketData(points, [], selectedDistrict).messageData
            this.setState({
                tableRow: transformedDataForTable
            })
        }
    }

    componentWillUnmount(){
        const { dispatch } = this.props
        dispatch(setHomePanelName(''))
    }

    // update selected district
    _handleDistrictChange = (e) => {
        const { dispatch } = this.props
        const newSelectedDistrict = e?.value ?? ''
        dispatch(setRunLoader(true))
        dispatch(setSelectedDistrict(newSelectedDistrict))
    }

    // get single point data, other data remains as it was. Store in reducer other than points
    // this is to show a single point data in map and open it's custop popup data while other data should also be visible as it was. Therefore, will store data in separated reducer instead of points
    loadSinglePointForCustomPopup = (uCode) => {
        const { dispatch } = this.props
    
        dispatch(setRunLoader(true))

        fetchCnlPlaceByUcode(uCode)
        .then(data => {

            dispatch(dispatch => {
                dispatch(setRenderSinglePoint(true))
                dispatch(setSingleDataPoint([data]))
                dispatch(setRunLoader(false))
            })

        })
        .catch(err => {
            console.error(err)
            dispatch(setRunLoader(false))
        })
    }


    // update date
    _handleDateChange = (date) => {
        const { dispatch } = this.props
        if(date?.startDate){
            dispatch(setStartDate(date?.startDate))
        }
        else if(date?.endDate){
            dispatch(setEndDate(date?.endDate))
        }
    }

    // start date type - created date or updated date
    _handleStartDateType = (e) => {
        const { dispatch } = this.props
        let startDateType = e.value
        console.log("startDateType name", startDateType);
        this.setState({ startDateType })
        dispatch(setStartDateType(startDateType))
    }

    render (){
        const { selectedDistrict, allDistrict, startDate, endDate } = this.props
        const { tableRow } = this.state

        return (
            <Box sx={{ minWidth: 120 }} style={{ overflowY: 'none', height: `${window.innerHeight-83}px`}}>
             <StyledDateRangePicker
                loadDataBtn={true}
                downloadBtn={true}
                dateRange={{ start: startDate, end: endDate }}
                handleDateChange={ this._handleDateChange }
            />
             <Box sx={{display: "flex", flexDirection: "row", justifyContent: "center", margin: "5px"}}>
                    <Typography ml={ 1 } mt={ 1 } fontSize={ 13 } variant={ 'body1' } htmlFor="outlet_categories">Start Date Type -  </Typography>
                    <Select
                        name='startDateType'
                        id='startDateType'
                        options={[
                            {
                                label: "Add Date",
                                value: 1
                            },
                            {   label: "Update Date",
                                value: 0
                            }
                        ]}
                        // label='outletCategories'
                        onChange={this._handleStartDateType}
                        placeholder="Start Date Type"
                        defaultValue={
                            {   label: "Update Date",
                                value: 0
                            }
                        }
                        isClearable={false}
                    />

                </Box>
            {/* <div style={{ display: 'block', width: '100%', padding: '0 10px'}}>
                <label style={label} htmlFor='accepting_deal'>select a district [Currently Selected - <span style={{color: '#f57876', fontWeight: 'bold'}}>{selectedDistrict ? selectedDistrict : 'All'}</span>]</label>
                <Select
                    name='district'
                    labelId='district-label'
                    id='district-label-id'
                    label='District'
                    onChange={this._handleDistrictChange}
                    style={{ display: 'block', width: '90%', padding: '5px'}}
                    options={allDistrict}
                    placeholder={'select a district' }
                    defaultValue={selectedDistrict ? { label: selectedDistrict, value: selectedDistrict} : 'None'}
                    classNamePrefix='select'
                    isClearable={false}
                    styles={customStyles}
                />
            </div> */}


            <hr style={{width: '60%', margin: '15px auto'}}/>
                <ReactWindowList 
                    tableRow={ tableRow }
                    loadSinglePointForCustomPopup={ this.loadSinglePointForCustomPopup }
                />
          </Box>
        )
    }
}

const label = {
    display: 'inline-block',
    // color: '#2d7b74',
    textAlign: 'left',
    fontSize: '12px',
    paddingLeft: '0'
  }

const customStyles = {
    control: base => ({
        ...base,
        minHeight: 20
    }),
    dropdownIndicator: base => ({
        ...base,
        padding: 2
    }),
    clearIndicator: base => ({
        ...base,
        padding: 2
    }),
    multiValue: base => ({
        ...base,
        // backgroundColor: 'red'
    }),
    valueContainer: base => ({
        ...base,
        padding: '0px 6px'
    }),
    input: base => ({
        ...base,
        margin: 0,
        padding: 0,
    })
};

// Prop Types
LoaderPanelCnl.propTypes = {
    points: PropTypes.array,
    staticPoints: PropTypes.array,
    socketRetailDataPoints: PropTypes.array,
    selectedDistrict: PropTypes.string,
    allDistrict: PropTypes.array,
    runLoader: PropTypes.bool,
}
LoaderPanelCnl.defaultProps = {
    points: [],
    staticPoints: [],
    socketRetailDataPoints: [],
    selectedDistrict: '',
    allDistrict: [],
    runLoader: false,
}


const mapStateToProps = (state) => ({
  points: state?.mapData?.points ?? [],
  staticPoints: state?.mapData?.staticPoints ?? [],
  socketRetailDataPoints: state?.mapData?.socketRetailDataPoints ?? [],
  selectedDistrict: state?.common?.selectedDistrict ?? '',
  allDistrict: state?.common?.allDistrict ?? [],
  runLoader: state?.mapData.runLoader ?? false,
  startDate: state?.common?.startDate ?? '',
  endDate: state?.common?.endDate ?? '',
})

const mapDispatchToProps = (dispatch) => ({dispatch})

export default connect(mapStateToProps, mapDispatchToProps)(LoaderPanelCnl);
